import React from "react";
import { NavigationMenu, NavigationMenuLink, NavigationMenuItem, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Link } from "react-router-dom";
interface DesktopNavigationProps {
  isScrolled: boolean;
}
const DesktopNavigation: React.FC<DesktopNavigationProps> = ({
  isScrolled
}) => {
  return <div className="hidden md:flex items-center space-x-1">
      <NavigationMenu>
        <NavigationMenuList className="flex items-center gap-0.5">
          <NavigationMenuItem>
            <Link to="/destinations" className={`group inline-flex h-10 w-max items-center justify-center px-2 py-2 text-sm font-normal transition-all duration-300 hover:scale-102 hover:shadow-sm hover:bg-black/10 rounded-lg ${isScrolled ? 'text-gray-700' : 'text-white'}`}>Nos destinations</Link>
          </NavigationMenuItem>
          <NavigationMenuItem>
            <span className={`${isScrolled ? 'text-gray-400' : 'text-white/60'}`}>|</span>
          </NavigationMenuItem>
          <NavigationMenuItem>
            <Link to="/about-us" className={`group inline-flex h-10 w-max items-center justify-center px-2 py-2 text-sm font-normal transition-all duration-300 hover:scale-102 hover:shadow-sm hover:bg-black/10 rounded-lg ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Notre histoire
            </Link>
          </NavigationMenuItem>
          <NavigationMenuItem>
            <span className={`${isScrolled ? 'text-gray-400' : 'text-white/60'}`}>|</span>
          </NavigationMenuItem>
          <NavigationMenuItem>
            <Link to="/tools" className={`group inline-flex h-10 w-max items-center justify-center px-2 py-2 text-sm font-normal transition-all duration-300 hover:scale-102 hover:shadow-sm hover:bg-black/10 rounded-lg ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Nos outils
            </Link>
          </NavigationMenuItem>
        </NavigationMenuList>
      </NavigationMenu>
    </div>;
};
export default DesktopNavigation;